import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import ConversationFactory from "../../Entity/Factories/ConversationFactory";
import { ConversationInterface } from "../../Entity/Entities/Conversation/ConversationInterface";

class ConversationUpdate extends SocketEvent implements SocketEventInterface {
  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const conversation: ConversationInterface = ConversationFactory.create(props.res);
    this.props.dispatch({
      type: Constants.GLOBAL_CONVERSATION_UPDATE_SUCCESS,
      payload: {
        conversation: conversation
      }
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CONVERSATIONS_LIST_OUTDATE_REQUESTS
    });
  }

}

export { ConversationUpdate };
